import React from 'react';
import PropTypes from 'prop-types';

// InputGroup / InputGroupText custom (from scratch) — remplacent ceux de reactstrap.
export const InputGroupText = ({ className, tag: Tag = 'span', children, ...attributes }) => {
  const classes = ['input-group-text', className].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...attributes}>
      {children}
    </Tag>
  );
};

InputGroupText.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const InputGroup = ({ className, size, tag: Tag = 'div', children, ...attributes }) => {
  const classes = ['input-group', size ? `input-group-${size}` : false, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} {...attributes}>
      {children}
    </Tag>
  );
};

InputGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

export default InputGroup;
